import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  private confirmSubject = new Subject<boolean>();
  confirm$ = this.confirmSubject.asObservable();

  private showDialog = new Subject<{
    message: string;
  }>();
  showDialog$ = this.showDialog.asObservable();

  requestConfirmation(message: string = 'Tem certeza?') {
    this.showDialog.next({ message });
    return this.confirm$;
  }

  confirm() {
    this.confirmSubject.next(true);
  }

  cancel() {
    this.confirmSubject.next(false);
  }
}
